import * as PropTypes from 'prop-types';
import Card from 'antd/lib/card';
import { FormattedMessage } from 'react-intl';
import { useFela } from 'react-fela';

import ImportTime from '../ImportTime';
import LogList from '../../containers/LogList';

import rule from './ImportDetail.rule';

const importPropTypes = {
    id: PropTypes.string.isRequired,
    startAt: PropTypes.instanceOf(Date),
    endAt: PropTypes.instanceOf(Date),
    importInProcess: PropTypes.bool.isRequired,
};

export const importShape = PropTypes.shape(importPropTypes);

const ImportDetail = ({ id, importInProcess, startAt, endAt }) => {
    const { css } = useFela();
    return (
        <div className={css(rule)}>
            <Card
                key={id}
                title={
                    importInProcess ? (
                        <FormattedMessage id="imports.detail.running" />
                    ) : (
                        <FormattedMessage id="imports.detail.done" />
                    )
                }
            >
                <ImportTime time={startAt} name="startAt" />
                <ImportTime time={endAt} name="endAt" />
                <LogList importId={id} />
            </Card>
        </div>
    );
};

ImportDetail.propTypes = importPropTypes;

ImportDetail.defaultProps = {
    startAt: null,
    endAt: null,
};

export default ImportDetail;
